<template>
  <div
    id="userListModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Naam</th>
                </tr>
              </thead>
              <tbody style="overflow:scroll">
                <tr v-for="(user, index) in users" :key="index">
                  <td>
                    <img
                      :src="user.profile_image"
                      style="width:70px;height:70px;border-radius:100%;"
                      alt="image"
                      v-if="user.profile_image != null"
                    />
                    <img
                      v-else
                      src="/assets/icon.jpg"
                      style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%"
                      alt=""
                    />
                  </td>
                  <td>
                    <a :href="'/profile/' + user.id + '/view'">{{
                      user.display_name
                    }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userlistmodel",
  props: ["users"],
};
</script>

<style lang="css" scoped></style>
